﻿let $ = require('jquery');
let _ = require('lodash');
let URI = require('urijs');
let Tracker = require('../Tracking/Tracker');

let DonationLevels = require('../DonationLevels');

let Donate = function (customOptions) {
	let defaults = {
		element: null,

		levelsContainerSelector: '.jnf-widget-donate-levels',
		loadingOverlaySelector: '.loading-overlay',

	};

	let options = $.extend({}, defaults, customOptions);

	if(options.element === null){
		throw new Error('element option required');
	}

	let $element = $(options.element);

	let formId = $element.data('form-id');
	let levelsContainer = $element.find(options.levelsContainerSelector);
	let luminateConfig = {
	    api_key: $element.data('api-key'),
	    v: $element.data('api-version')
	};
	
    let donationLevels = new DonationLevels({
	    formId: formId,
	    levelsContainer: levelsContainer,
	    luminateConfig: luminateConfig,
	    selectFirstOption: false,
        customAmountPlaceholder: 'My Preferred Amount',
    });

    donationLevels.onAmountChange = amount => {
        Tracker.donateTodayLevelSelected({
            page: window.location.pathname,
            formId: formId,
            donationAmount: amount,
            preselectedAmoutChosen: donationLevels.isSelectedLevelPredefined()
        });
    }
    
    donationLevels.initialize()
        .finally(() => {
            let overlay = $element.find(options.loadingOverlaySelector);
            overlay.css('opacity', 0);
            overlay.css('visibility', 'hidden');
        }).done();

    $('.jnf-widget-donate-submit').click(e => {
        e.preventDefault();

        Tracker.donateTodayNextClicked({
            page: window.location.pathname,
            formId: formId,
            donationAmount: donationLevels.selectedAmount,
            preselectedAmoutChosen: donationLevels.isSelectedLevelPredefined()
        });

        let url = $($element.data('submit-url')).attr('href');

        if (url) {
            window.location.href = URI(url).query({
                formId: formId,
                levelId: donationLevels.selectedLevelId,
                amount: donationLevels.selectedAmount
            });
        }
    });
};

module.exports = Donate;